/**
 * @generated SignedSource<<20ddcfda002bad1546a96efc68a52fbf>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type modulesNamesFragment$data = {
  readonly preferences: {
    readonly feedback: {
      readonly module: {
        readonly name: string;
        readonly pluralName: string;
      };
    };
    readonly feedbackOneToOne: {
      readonly module: {
        readonly name: string;
      };
    };
  };
  readonly " $fragmentType": "modulesNamesFragment";
};
export type modulesNamesFragment$key = {
  readonly " $data"?: modulesNamesFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"modulesNamesFragment">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "modulesNamesFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "CompanyPreferences",
      "kind": "LinkedField",
      "name": "preferences",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "CompanyPreferencesFeedback",
          "kind": "LinkedField",
          "name": "feedback",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "FeedbackModulePreferences",
              "kind": "LinkedField",
              "name": "module",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "pluralName",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "CompanyPreferencesFeedbackOneToOne",
          "kind": "LinkedField",
          "name": "feedbackOneToOne",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "FeedbackOneToOneModulePreferences",
              "kind": "LinkedField",
              "name": "module",
              "plural": false,
              "selections": [
                (v0/*: any*/)
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Company",
  "abstractKey": null
};
})();

(node as any).hash = "8d0ea25dd44ef1194d52d94939e05825";

export default node;
